/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import { GetTour } from './Tours.jsx';

export function RunIndeepDesc(props) {

    return(
        <div className="flex flex-col md:flex-row items-center">
            <div>
                <h1 className='font-bold text-xl md:text-2xl py-2 dark:text-white'>Run Indeep</h1>
                <div className="flex flex-row items-center">
                <small className='text-justify py-2 text-gray-600 dark:text-gray-50'>
                To run InDeep, select a mode to load and visualize a structure, optionally select part of the structure, provide your email (optional), and click the 'Detect Pocket' button. Test InDeep<sup>Net</sup> with our tour.
                <GetTour plugin={ props.plugin }/>
                </small>
                </div>
            </div>
        </div>
    )
}